// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { lastValueFrom } from "rxjs";
import { AppEnvironmentService } from "./services/app-environment.service";
import { AuthService } from "./services/auth/auth.service";


export function appInitializer(appEnvironmentService: AppEnvironmentService, authService: AuthService): () => Promise<any> {
    return (): Promise<any> => {
        return new Promise((resolve, reject) => {
            lastValueFrom(appEnvironmentService.loadAppEnvironmentData()).then(data => {

                appEnvironmentService.setAppEnvironmentData(data);
                authService.initAuth0();
                resolve(true);
            }).catch(error => {

                reject(error);
            });
        });
    };
}